globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modules = appCustomerSpace.Modules || {};

appCustomerSpace.Modules.Coaching = (function() {

  function Coaching() {
    this.init();
  }

  Coaching.prototype = {
    init : function() {
      var coaching = this;

      coaching.$panels = $('.panel-coaching');
      coaching.$panels.each(function(){ coaching.initializePanel($(this)); });
    },
    initializePanel: function($panel) {
      var coaching = this;

      $panel.on('submit', 'form.edit_accounts_coaching_abstract_tip', function(){
        var $form = $(this),
            $tip = $form.closest('.media-link');

        appCustomerSpace.Loader().start({ $container: $tip, options: {text: false} });

        $.ajax({
          url: $form.attr('action'),
          method: 'PATCH',
          data: $form.serialize(),
          success: function(data) {
            if(data.response) {
              var $updatedPanel = $(data.views.panel);
              coaching.initializePanel($updatedPanel);
              $panel.replaceWith($updatedPanel);
            } else {
              alert('Action impossible.')
            }
          },
          error: function(data){
            alert('Action impossible.')
          }
        })

        return false;
      });
    }
  }

  return Coaching;

})();
